import React, { useEffect } from 'react';
import { TopBarState } from '../../component/top-bar/top-bar-state';
import { MobxObjectsManager } from '../mobx-objs/mobx-manager';
import { observer } from 'mobx-react-lite';
import i18n from '../../i18n';
import './scss/data-analysis.style.scss';
import DashboardsDataPage from './dashboards-data/dashboards-data.page';
import OrderDataPage from './order-data/order-data.page';
import RefundDishDataPage from './refund-data/refund-data.page';
import SensitiveDataPage from './sensitive-data/sensitive-data.page';
import { Box, Typography } from '@mui/material';
import dataAnalysisStore from './data-analysis-state';
import ScrollTabs from '../../component/tab/scroll-tabs.component';
import MainPageState, { HookDecorator } from '../main/main-page-states';
import moment from 'moment';
import { validateCurrentDate } from '../../constants/tool-order';

const topBarState = MobxObjectsManager.get(TopBarState);
const mainPageData = MobxObjectsManager.get(MainPageState);

/**
 * 经营分析内容区；隧道与当前餐厅校验仅在父级通过 `HookDecorator` 执行一次（与「子功能管理」壳页一致）。
 */
const DataAnalysisManagementContent = observer(() => {
    // tabs数组
    const Tab_DATA = [
        {
            title: i18n.t('business_analysis_page_text_immediate_info')
        },
        {
            title: i18n.t('immediate_order_data')
        },
        {
            title: i18n.t('business_analysis_page_immediate_return_details')
        },
        {
            title: i18n.t('business_analysis_page_immediate_sensitive_operation_record')
        },
    ]

    useEffect(() => {
        // 设置当前餐馆
        dataAnalysisStore.setCurrentRestaurant(mainPageData.currentRestaurant);
        // 设置所属餐馆
        dataAnalysisStore.setBelongedRestaurant(mainPageData.belongedRestaurant);
        // 更新标题
        topBarState.updateDataAnalysisTitle();
        return () => {
            dataAnalysisStore.setActiveTabIndex(0);
            const { startTime, endTime } = validateCurrentDate();
            dataAnalysisStore.handleDateTime([moment(startTime, 'YYYY-MM-DD HH:mm').toDate(), moment(endTime, 'YYYY-MM-DD HH:mm').toDate()]);
        }
    }, [])

    useEffect(() => {
        // 设置所属餐馆
        dataAnalysisStore.setBelongedRestaurant(mainPageData.belongedRestaurant);
    }, [mainPageData.belongedRestaurant])
    useEffect(() => {
        // 设置当前餐馆
        dataAnalysisStore.setCurrentRestaurant(mainPageData.currentRestaurant);
    }, [mainPageData.currentRestaurant])

    /**
     * 切换tab
     * @param value
     */
    const handleChangeTab = (value: number) => {
        dataAnalysisStore.setActiveTabIndex(value)
    }

    /**
     * 子页面渲染
     */
    const renderPage = () => {

        switch (dataAnalysisStore.activeTabIndex) {
            case 0:
                // 当前营业数据
                return <DashboardsDataPage />
            case 1:
                // 当前订单详情
                return <OrderDataPage />
            case 2:
                // 当前退菜详情
                return <RefundDishDataPage pageType='INSTANT' />
            case 3:
                // 当前敏感操作记录
                return <SensitiveDataPage pageType='INSTANT' />
            default:
                return <></>
        }
    }

    return (
        !dataAnalysisStore.currentRestaurant?.restaurant_version ?
            <Box sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                height: '100%'
            }}>
                <Typography variant='body1'>
                    {
                        dataAnalysisStore.belongedRestaurant.length === 0 ?
                            i18n.t('business_analysis_page_none_restaurant') :
                            i18n.t('business_analysis_page_please_select_restaurant_version_first')
                    }
                </Typography>
            </Box>
            :
            <>
                <ScrollTabs
                    data={Tab_DATA}
                    activeIndex={dataAnalysisStore.activeTabIndex}
                    onClick={handleChangeTab}
                />
                {renderPage()}
            </>
    )
})

export default HookDecorator(function DataAnalysisManagement() {
    return <DataAnalysisManagementContent />;
})


export function ErrorMessageBox(params: { errorMessage: string, height?: number }) {
    return <Box sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: params?.height ?? 500
    }}>
        <Typography variant='body1'>
            {params.errorMessage}
        </Typography>
    </Box>
}